const DB_NAME = "dotson_custom_media";
const STORE_NAME = "videos";

export function saveVideoBlob(blob: Blob): void {
  try {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE_NAME)) {
        req.result.createObjectStore(STORE_NAME);
      }
    };
    req.onsuccess = () => {
      const tx = req.result.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).put(blob, "hero_video");
    };
  } catch (e) {
    console.error("Failed to save video", e);
  }
}

export function loadVideoBlob(callback: (url: string) => void): void {
  try {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE_NAME)) {
        req.result.createObjectStore(STORE_NAME);
      }
    };
    req.onsuccess = () => {
      const tx = req.result.transaction(STORE_NAME, "readonly");
      const getReq = tx.objectStore(STORE_NAME).get("hero_video");
      getReq.onsuccess = () => {
        if (getReq.result instanceof Blob) {
          callback(URL.createObjectURL(getReq.result));
        }
      };
    };
  } catch (e) {
    console.error("Failed to load video", e);
  }
}
